import { t } from '@lingui/macro';

export const customizationLabels = (ctoType = '') => {
  const rules = {
    memory: t({ id: 'customization.label.memory', message: `Memory` }),
    color: t({ id: 'customization.label.color', message: `Colour` }),
    screen: t({ id: 'customization.label.screen', message: `Screen` }),
    cpu: t({ id: 'customization.label.cpu', message: `Cpu` }),
    storage: t({ id: 'customization.label.storage', message: `Storage` }),
    connectivity: t({
      id: 'customization.label.connectivity',
      message: `Connectivity`,
    }),
    graphics: t({ id: 'customization.label.graphics', message: `Graphics` }),
    keyboard: t({ id: 'customization.label.keyboard', message: `Keyboard` }),
    power: t({ id: 'customization.label.power', message: `Power` }),
    touchbar: t({ id: 'customization.label.touchbar', message: `Touchbar` }),
    mouse: t({ id: 'customization.label.mouse', message: `Mouse` }),
    vesamount: t({ id: 'customization.label.vesamount', message: `Vesamount` }),
    ethernet: t({ id: 'customization.label.ethernet', message: `Ethernet` }),
    spec: t({ id: 'customization.label.spec', message: `Spec` }),
    glass: t({ id: 'customization.label.glass', message: `Glass` }),
    movability: t({
      id: 'customization.label.movability',
      message: `Movability`,
    }),
    afterburner: t({
      id: 'customization.label.afterburner',
      message: `Afterburner`,
    }),
    racktower: t({ id: 'customization.label.racktower', message: `Racktower` }),
    neural_engine: t({
      id: 'customization.label.neural.engine',
      message: `Neural engine`,
    }),
    gigabit: t({ id: 'customization.label.gigabit', message: `Gigabit` }),
    adaptor: t({ id: 'customization.label.adaptor', message: `Power adapter` }),
    duration: t({ id: 'product.options.duration', message: 'Duration' }),
    accidental_damage_protection: t({
      id: 'product.options.accidental_damage_protection',
      message: 'Accidental Damage Protection',
    }),
    defective_media_retention: t({
      id: 'product.options.defective_media_retention',
      message: 'Defective Media Retention',
    }),
    device_life_extension: t({
      id: 'product.options.device_life_extension',
      message: 'Device Life Extension',
    }),
    pc_solution: t({
      id: 'product.options.pc_solution',
      message: 'Pc Solution',
    }),
    travel_coverage: t({
      id: 'product.options.travel_coverage',
      message: 'Travel Coverage',
    }),
    data_capture: t({
      id: 'product.options.data_capture',
      message: 'Data Capture',
    }),
    location: t({ id: 'product.options.location', message: 'Location' }),
    barcode: t({ id: 'product.options.barcode', message: 'Barcode' }),
    device_enrolment: t({
      id: 'product.options.device_enrolment',
      message: 'Device Enrolment',
    }),
    test_report: t({
      id: 'product.options.test_report',
      message: 'Test Report',
    }),
  };

  return rules[`${ctoType}`.toLowerCase()] || ctoType;
};
